'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.stepper__wrapper {\n  list-style: none;\n  padding-left: 0;\n}\n.stepper__wrapper .stepper__item {\n  position: relative;\n  margin-bottom: calc(0.75 * 1rem);\n}\n.stepper__wrapper .stepper__item .stepper {\n  display: flex;\n}\n.stepper__wrapper .stepper__item .stepper__button {\n  border-color: #1D66DD;\n  background: #1D66DD;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n}\n.stepper__wrapper .stepper__item .stepper span {\n  margin-left: calc(0.75 * 1rem);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.stepper__wrapper .stepper__item .stepper span p {\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 400;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.stepper__wrapper .stepper__item:not(:first-child) .stepper__button::after {\n  border: 1px solid #1D66DD;\n  background-color: #1D66DD;\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: -5px;\n  width: 100%;\n  z-index: -1;\n  transform: rotate(90deg);\n}");
//# sourceMappingURL=Stepper.scss.js.map
